// FAZ-10.6 / K-37 — şablon galerisi: FE-statik preset'ler. Her preset atomik
// bloklardan BE-sözleşme uyumlu componentJson üretir (composite'ler AYRI blok tipi
// DEĞİL — kompozisyon). İçerik STATİKtir (`{{key}}` placeholder YOK → undeclared
// placeholder 422 riski yok; kullanıcı editörde özelleştirir). Yeni bir bileşende
// "Boş / Şablondan" seçiminde tuvale tohum olur; `templates.test.ts` her preset'i
// serialization round-trip'inden geçirir.

/** Bir içerik dizisini BE canonical `{root:{},content:[]}` metnine sarar. */
function cj(content: unknown[]): string {
  return JSON.stringify({ root: {}, content });
}

export interface ComponentTemplatePreset {
  /** Kararlı id (i18n `templates.<id>.name/.description`). */
  id: string;
  /** Sözleşme-uyumlu componentJson (statik içerik). */
  componentJson: string;
}

const HERO = cj([
  {
    type: 'container',
    props: {
      align: 'center',
      padding: 'large',
      children: [
        { type: 'heading', props: { text: 'Hero başlığı', level: 1 } },
        { type: 'text', props: { html: '<p>Kısa ve etkileyici bir açıklama metni.</p>' } },
        { type: 'button', props: { label: 'Hemen Başla', href: '/', variant: 'primary' } },
      ],
    },
  },
]);

function card(title: string): unknown {
  return {
    type: 'container',
    props: {
      padding: 'medium',
      children: [
        { type: 'heading', props: { text: title, level: 3 } },
        { type: 'text', props: { html: '<p>Kart açıklaması.</p>' } },
      ],
    },
  };
}

const CARD_GRID = cj([
  {
    type: 'grid',
    props: {
      columnCount: 3,
      col1: [card('Kart 1')],
      col2: [card('Kart 2')],
      col3: [card('Kart 3')],
    },
  },
]);

const TESTIMONIAL = cj([
  {
    type: 'container',
    props: {
      padding: 'medium',
      children: [
        { type: 'quote', props: { text: 'Bu ürün işimizi kökten değiştirdi.', author: 'Ad Soyad, Şirket' } },
      ],
    },
  },
]);

function priceCard(plan: string, price: string): unknown {
  return {
    type: 'container',
    props: {
      padding: 'medium',
      children: [
        { type: 'heading', props: { text: plan, level: 3 } },
        { type: 'stat', props: { value: price, label: '/ ay' } },
        { type: 'list', props: { items: ['Özellik bir', 'Özellik iki', 'Özellik üç'], ordered: false } },
        { type: 'button', props: { label: 'Seç', href: '/', variant: 'primary' } },
      ],
    },
  };
}

const PRICING = cj([
  {
    type: 'grid',
    props: {
      columnCount: 3,
      col1: [priceCard('Başlangıç', '₺99')],
      col2: [priceCard('Standart', '₺199')],
      col3: [priceCard('Premium', '₺399')],
    },
  },
]);

const FAQ = cj([
  {
    type: 'container',
    props: {
      children: [
        { type: 'heading', props: { text: 'Sıkça Sorulan Sorular', level: 2 } },
        { type: 'accordion', props: { title: 'İlk soru?', html: '<p>İlk sorunun cevabı.</p>' } },
        { type: 'accordion', props: { title: 'İkinci soru?', html: '<p>İkinci sorunun cevabı.</p>' } },
      ],
    },
  },
]);

const STAT_STRIP = cj([
  {
    type: 'grid',
    props: {
      columnCount: 3,
      col1: [{ type: 'stat', props: { value: '10K+', label: 'Müşteri' } }],
      col2: [{ type: 'stat', props: { value: '%99', label: 'Memnuniyet' } }],
      col3: [{ type: 'stat', props: { value: '7/24', label: 'Destek' } }],
    },
  },
]);

const CAMPAIGN = cj([
  {
    type: 'container',
    props: {
      background: 'brand',
      padding: 'large',
      children: [
        { type: 'badge', props: { label: 'Kampanya', tone: 'brand' } },
        { type: 'heading', props: { text: 'Sınırlı süre fırsatı', level: 2 } },
        { type: 'text', props: { html: '<p>Kampanya detaylarını buraya yazın.</p>' } },
        { type: 'button', props: { label: 'Fırsatı Yakala', href: '/', variant: 'primary' } },
      ],
    },
  },
]);

/** 7 FE-statik preset (kullanıcı composite direktifi). i18n meta `templates.<id>`. */
export const COMPONENT_TEMPLATES: ComponentTemplatePreset[] = [
  { id: 'hero', componentJson: HERO },
  { id: 'cardGrid', componentJson: CARD_GRID },
  { id: 'testimonial', componentJson: TESTIMONIAL },
  { id: 'pricing', componentJson: PRICING },
  { id: 'faq', componentJson: FAQ },
  { id: 'statStrip', componentJson: STAT_STRIP },
  { id: 'campaign', componentJson: CAMPAIGN },
];

export function findTemplate(id: string | undefined): ComponentTemplatePreset | undefined {
  return id ? COMPONENT_TEMPLATES.find((tpl) => tpl.id === id) : undefined;
}

/** BE sözleşmesindeki geçerli boş ağaç — create'in COMPONENT_SOURCE_REQUIRED'a takılmaması için. */
export const EMPTY_COMPONENT_JSON = '{"root":{},"content":[]}';

/**
 * Create isteğinin componentJson tohumu: şablon seçiliyse şablonun ağacı, değilse
 * (Boş mod / bilinmeyen id) boş-geçerli ağaç. Create HER ZAMAN kaynak taşır.
 */
export function buildCreateSeed(templateId: string | undefined): string {
  return findTemplate(templateId)?.componentJson ?? EMPTY_COMPONENT_JSON;
}
